import React from 'react';
import { BookOpen, Users, Search } from 'lucide-react';
import { Button } from './Button';
export function KeyInfo() {
  const cards = [{
    title: 'BOOK:',
    icon: BookOpen,
    content: 'Attorney Jason Waechter has authored comprehensive materials and is recognized extensively in the field of trucking injury law. We know the rules that govern commercial drivers.'
  }, {
    title: 'CONNECTED:',
    icon: Users,
    content: 'We are connected with top truck accident attorneys nationwide. When you hire us, you get a network of legal professionals dedicated to holding negligent trucking companies accountable.'
  }, {
    title: 'RESEARCH:',
    icon: Search,
    content: 'We perform extensive research and case preparation on FMCSR and trucking regulations. We dig deep into driver logs, maintenance records, and corporate safety histories.'
  }];
  return <section className="py-16 bg-white" data-id="element-170">
      <div className="max-w-legal-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-172">
          {cards.map((card, index) => {
          const Icon = card.icon;
          return <div key={index} className="bg-legal-light p-8 rounded-lg border-t-4 border-legal-red" data-id="element-173">
                <Icon className="w-10 h-10 text-legal-red mb-6" data-id="element-174" />
                <h3 className="text-xl font-bold text-legal-dark mb-4" data-id="element-175">
                  {card.title}
                </h3>
                <p className="text-legal-gray leading-relaxed" data-id="element-176">
                  {card.content}
                </p>
              </div>;
        })}
        </div>

        {/* CTA Band */}
        <div className="bg-legal-dark rounded-xl p-8 md:p-12 text-center text-white shadow-xl relative overflow-hidden" data-id="element-177">
          <div className="absolute top-0 left-0 w-2 h-full bg-legal-red" data-id="element-178"></div>
          <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-179">
            A truck accident case can depend on fast evidence preservation.
          </h3>
          <p className="text-gray-300 text-lg mb-8 max-w-3xl mx-auto" data-id="element-180">
            Call now or contact the firm to discuss your tractor trailer, semi
            truck, or commercial vehicle accident case.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-181">
            <Button href="11014.html" variant="primary" size="lg" icon="mail" data-id="element-182">
              Get a Free Case Assessment
            </Button>
            <Button href="tel:18007085433" variant="outline" size="lg" icon="phone" className="border-white text-white hover:bg-white hover:text-legal-dark" data-id="element-183">
              Call 1-800-708-5433
            </Button>
          </div>
        </div>
      </div>
    </section>;
}